/**
 * Created by atyun on 17/5/24.
 */
export default {
    getComponent(nextState, cb) {
        // require.ensure([], (require) => {
            cb(null, require('./Home_change').default)
        // })
    }
}